import AuthAPI from './AuthAPI';
import { AuthIDPConfig } from './AuthIDPAPI.model';
import { initializeAuthConfig } from '../../shared/util/auth/oidcUtils';

const AuthIDPAPI = AuthAPI.injectEndpoints({
  endpoints(build) {
    return {
      getIDPConfig: build.query<AuthIDPConfig, void>({
        queryFn: async () => {
          const result = await initializeAuthConfig();
          if (!result.success || !result.OIDC_CONFIG) {
            return {
              error: {
                status: 500,
                data: result.error || 'Failed to fetch IDP config',
                message: result.error || 'Failed to fetch IDP config',
              },
            };
          }
          const config = result.OIDC_CONFIG;
          return {
            data: {
              name: config.name || null,
              description: config.description || null,
              provider: config.provider || null,
              wsUuid: config.wsUuid || null,
              providerUrl: config.providerUrl || null,
              clientId: config.clientId || null,
              scope: config.scope || null,
            },
          };
        },
        providesTags: ['auth-config'],
      }),
    };
  },
});

export default AuthIDPAPI;
